import React from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardActionArea,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import BusinessIcon from "@mui/icons-material/Business";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { colorDeEmpresa } from "./coloresEmpresas";

const idDeEmpresa = (emp) =>
  emp?.idempresa ?? emp?.id_empresa ?? emp?.id ?? null;

const nombreDeEmpresa = (emp) =>
  emp?.empresa ?? emp?.nombre ?? emp?.nombre_empresa ?? `Empresa ${idDeEmpresa(emp)}`;

const TabSeleccionEmpresa = ({
  empresas = [],
  loading = false,
  error = "",
  idEmpresaSeleccionada = null,
  onSelect,
  onContinuar,
}) => {
  const puedeContinuar = idEmpresaSeleccionada != null && idEmpresaSeleccionada !== "";

  return (
    <Paper
      elevation={1}
      sx={{
        p: 3,
        backgroundColor: "#fff",
        border: "1px solid #e0e0e0",
      }}
    >
      <Typography variant="h6" fontWeight={700} gutterBottom>
        Seleccioná la empresa
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Elegí la empresa con la que vas a operar. El color de la pantalla se
        ajustará según la selección.
      </Typography>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {!loading && !error && empresas.length === 0 && (
        <Alert severity="info">No hay empresas disponibles.</Alert>
      )}

      <Grid container spacing={1.5}>
        {empresas.map((emp) => {
          const id = idDeEmpresa(emp);
          const nombre = nombreDeEmpresa(emp);
          const color = colorDeEmpresa(id);
          const seleccionada = String(id) === String(idEmpresaSeleccionada);

          return (
            <Grid item xs={6} sm={4} md={3} lg={2} key={String(id)}>
              <Card
                elevation={seleccionada ? 3 : 0}
                sx={{
                  border: "2px solid",
                  borderColor: seleccionada ? color : "#e8e8e8",
                  backgroundColor: seleccionada ? `${color}14` : "#fff",
                  transition: "border-color 0.2s, background-color 0.2s, box-shadow 0.2s",
                }}
              >
                <CardActionArea
                  onClick={() => onSelect?.(emp)}
                  sx={{ px: 1.5, py: 1.25 }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 0.75,
                    }}
                  >
                    <Box sx={{ display: "flex", gap: 1, alignItems: "center", minWidth: 0 }}>
                      <Box
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: 0.75,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: color,
                          color: "#fff",
                          flexShrink: 0,
                        }}
                      >
                        <BusinessIcon sx={{ fontSize: 16 }} />
                      </Box>
                      <Typography
                        variant="body2"
                        fontWeight={700}
                        noWrap
                        title={nombre}
                      >
                        {nombre}
                      </Typography>
                    </Box>
                    {seleccionada && (
                      <CheckCircleIcon sx={{ color, fontSize: 18, flexShrink: 0 }} />
                    )}
                  </Box>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          disabled={!puedeContinuar}
          onClick={onContinuar}
        >
          Continuar
        </Button>
      </Box>
    </Paper>
  );
};

export default TabSeleccionEmpresa;
export { idDeEmpresa, nombreDeEmpresa };
